import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"
import Link from "next/link"
import { Image } from "react-datocms"
import colors from "@constants/colors"
import { bodyBold } from "@constants/typography"
import { DatoResponsiveImage } from "@dato/types"

export const Container = styled.a`
  flex-direction: column;
  display: flex;
  width: 144px;
  min-height: 176px;
  padding-bottom: 12px;
  background-color: ${colors.grayCard};

  ${up("laptop")} {
    background-color: ${colors.divider};

    &:hover {
      cursor: pointer;
      background-color: ${colors.dividerHover};
    }
  }
`

export const ImageWrapper = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  width: 144px;
  height: 144px;
  padding: 0px;

  .DatoImage {
    width: 100%;
    height: 100%;

    div {
      opacity: 0 !important;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center center;
    }
  }
`

export const Title = styled.div`
  ${bodyBold}
  width: 100%;
  text-align: center;
  color: ${colors.slateDark};
`

export interface ProductStyleCardProps {
  url?: string
  image: DatoResponsiveImage
  title: string
  className?: string
  onClick?: any
}

const ProductStyleCard: React.FC<ProductStyleCardProps> = ({
  url,
  image,
  title,
  onClick,
  className,
}) => {
  return url ? (
    <Link href={url} passHref>
      <Container className={className}>
        <ImageWrapper>
          <Image
            data={{ ...image, bgColor: "transparent" }}
            className="DatoImage"
          />
        </ImageWrapper>
        <Title>{title}</Title>
      </Container>
    </Link>
  ) : (
    <Container
      onClick={() => onClick({ image: image, title: title })}
      className={className}
    >
      <ImageWrapper>
        <Image
          data={{ ...image, bgColor: "transparent" }}
          className="DatoImage"
        />
      </ImageWrapper>
      <Title>{title}</Title>
    </Container>
  )
}

export default ProductStyleCard
